import request from '@/utils/request'

// 查询费用套餐列表
export function listFeeCombo(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeCombo.listFeeCombo',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加费用套餐
export function saveFeeCombo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeCombo.saveFeeCombo',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改费用套餐
export function updateFeeCombo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeCombo.updateFeeCombo',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除费用套餐
export function deleteFeeCombo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeCombo.deleteFeeCombo',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
